<app-header></app-header>
<app-sidebar></app-sidebar>
<div class="content-wrapper" style="min-height: 307px">
    <div class="col-lg-12">
        <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="timer" [fullScreen]="false">
            <p style="color: white">
                Loading... </p>
        </ngx-spinner>
        <!-- แบบบันทึกทั้งหมดนั่นล่ะ -->
        <div class="card">
            <div class="card-header bg-primary">แบบฟอร์มขอเบิกปัจจัย 66/67</div>
            <div class="card-body">
                <div class="row">
                    <form [formGroup]="Formfactor">
                        <div class="input-group mb-3 col-8" *ngIf="famerlist != null">
                            <span class="input-group-text" id="basic-addon1">เลือกชาวไร่</span>
                            <input type="text" class="form-control" placeholder="ป้อนรหัสโควตา" list="farmer"
                                [ngModelOptions]="{standalone: true}" [(ngModel)]="fmcode" id="codefm"
                                (change)="goloaddata()">
                            <datalist id="farmer">
                                <option *ngFor="let item of famerlist">
                                    [{{item.fmcode_b1}}] {{item.fmname}} จำนวนแปลง {{item.cnt}}
                                    <lable *ngIf="item.approve==='Y'">เบิกได้</lable>
                                    <lable *ngIf="item.PromiseIN == 0">สัญญายังไม่ผ่าน</lable>
                                    <lable *ngIf="item.zoneban ==='Y' ">อยู่โซนต้องห้าม</lable>
                                </option>
                            </datalist>
                            <div class="input-group-append">
                                <div class="input-group-text">
                                    <input class="form-check-input" type="checkbox" formControlName="cash"
                                        [(ngModel)]="ckcash" name="cash0" (change)="ckack()"> <label for="cash0">
                                        เงินสด</label>
                                </div>
                            </div>
                            <div class="input-group-append">
                                <button class="btn btn-default float-right" (click)="clearFm();">กรอกใหม่</button>
                            </div>
                        </div>

                        <!--
                        <div class="input-group mb-3 col-10" *ngIf="famerlist != null">
                            <span class="input-group-text" id="basic-addon1">เบิกปัจจัย 66/67</span>
                            <input type="text" class="form-control" placeholder="ป้อนรหัสโควตา" list="farmer" id="codefm" (change)="goloaddata()">
                            <datalist  id="farmer">
                                <option  *ngFor="let item of famerlist">
                                    [{{item.fmcode_b1}}] {{item.fmname}} จำนวนแปลง {{item.cnt}}
                                <lable *ngIf="item.approve==='Y'">เบิกได้</lable>
                                    <lable *ngIf="item.PromiseIN == 0">สัญญายังไม่ผ่าน</lable>
                                    <lable *ngIf="item.zoneban ==='Y' ">อยู่โซนต้องห้าม</lable>
                                </option>
                            </datalist> 
                        </div> 
                        <div class="input-group mb-1 col-2" >
                            <input class="form-check-input" type="checkbox" formControlName="cash" [(ngModel)]="ckcash" name="cash0" (change)="ckack()"> <label for="cash0" > เงินสด</label> 
                        </div>
                        -->
                    </form>
                    <!-- รายการชาวไร่  -->
                    <div class="col-5">
                        <div class="card">
                            <div class="card col-sm-12">
                                <!--<button class="btn btn-outline-dark" (click)="goloaddata();"><i class="fas fa-search"></i></button>-->
                                <!--<div class="col-4">
                                        <p style="color: red;">ตัวอย่าง [0123456789] </p>
                                    </div>
                                    -->
                                <div class="col-md-12 ml-md">
                                    <table style="width:100%">
                                        <tr style="text-align:center">
                                            <th>วงเงินทั้งหมด</th>
                                            <th>ยอดหนี้ปี 66/67 </th>
                                            <th>วงเงินที่ใช้ไป</th>
                                            <th>วงเงินที่ขอเกี้ยว </th>
                                            <th>วงเงินเบิกปัจจัย</th>
                                            <th>วงเงินคงเหลือ</th>
                                        </tr>
                                        <tr style="text-align:center">
                                            <td>{{credit|number}}</td>
                                            <td>{{RSUM_long|number}}</td>
                                            <td>{{sum_money_amt|number}}</td>
                                            <td>{{sum_money_amt1|number}}</td>
                                            <td>{{sum_money_amt2|number}}</td>
                                            <td style="color: red;">{{limit|number}}</td>
                                        </tr>
                                    </table>
                                </div>
                                <hr />

                                <div class="card-body table-responsive p-2" style="height: 620px">
                                    <table #tb_data class="table table-head-fixed text-nowrap">
                                        <thead>
                                            <tr class="headText text-primary" style="text-align:center">
                                                <th>.</th>
                                                <th>เลขแปลง</th>
                                                <th>โซน</th>
                                                <th>รูท</th>
                                                <th>ประเภท</th>
                                                <th>พื้นที่</th>
                                                <th>เบิกได้</th>
                                                <th>เบิกแล้ว</th>
                                                <th>เลือก</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let item of dataonefarmer; let i = index;"
                                                style="text-align:center">
                                                <td>{{i+1}}</td>
                                                <td>{{item.intlandno}}</td>
                                                <td>{{item.supzone}}</td>
                                                <td>{{item.route}}</td>
                                                <td>{{item.canetype}}</td>
                                                <td>{{item.landvalue | number }}</td>
                                                <td>{{item.caneGetfert12}}</td>
                                                <td>{{item.Getferted}}</td>
                                                <td><button class="btn btn-success btn-sm"
                                                        (click)="Selectoneplant(item.itid);" *ngIf="!ckfarmercan"><i
                                                            class="fas fa-check-circle"></i></button></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- รายการชาวไร่  -->

                    <!-- ฟอร์มบันทึกกรอกปัจจัย -->
                    <div class="col-7" [hidden]="ckfarmercan">
                        <div class="card">
                            <div class="card-header bg-warning"> ฟอร์มขอเบิกปัจจัยการผลิตปี 66/67 </div>
                            <div class="card-body" *ngIf="oneplant.length>0">
                                <form [formGroup]="Formfactor">
                                    <table class="table-head-fixed" cellspacing="0" style="width: 100%">
                                        <tr style="text-align:center">
                                            <td style="width: 30%">{{famername}} </td>
                                            <td style="width: 40%"><a> แปลง {{intlandno}}</a>
                                                <!--<input type="text" class="form-control" [value]="intlandno" disabled></td>-->
                                            <td style="width: 30%"><a> ประเภทอ้อย {{detailsplant}} ไร่</a></td>
                                        </tr>
                                        <tr>
                                            <td style="text-align:center">สต๊อก </td>
                                            <td style="text-align:center">
                                                <mat-form-field appearance="fill">
                                                    <mat-label>สต๊อก</mat-label>
                                                    <mat-select disableRipple required formControlName="localstock"
                                                        (selectionChange)="Changetock()">
                                                        <mat-option [value]="" disabled>กรุณาเลือกสต๊อก</mat-option>
                                                        <mat-option *ngFor="let item of fertilizerstock"
                                                            [value]="item.StockID">สต๊อก-{{item.Stockname}}
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                                <!--
                                            <select class="form-control" formControlName="localstock" (change)="Changetock()" 
                                            [ngClass]="{ 'is-invalid': submitted && factor.localstock.errors }">
                                                <option [value]="" disabled selected >กรุณาเลือก</option>
                                                <option *ngFor="let item of fertilizerstock" [ngValue]="item.StockID">{{item.Stockname}}</option>
                                            </select>
                                            -->
                                            </td>
                                            <td></td>
                                        </tr>
                                        <!--<div *ngIf="submitted && factor.localstock.errors" class="invalid-feedback">
                                        <div *ngIf="factor.localstock.errors?.required" >กรุณาเลือก Stock </div>
                                    </div>-->
                                    </table>

                                    <hr>

                                    <!--<table #tb_data class="table table-hover table-head-fixed text-nowrap" style="width:100%;">-->
                                    <table class="table-head-fixed example-full-width" cellspacing="0"
                                        style="width: 100%" *ngIf="main_stock!=''">
                                        <tr class="header" style="text-align:center">
                                            <!--<th style="width:10%"></th>-->
                                            <th colspan="2" style="width:44%;">รหัสสินค้า</th>
                                            <th scope="col" style="width:11%;">ราคา</th>
                                            <th scope="col" style="width:11%;">จำนวน</th>
                                            <th scope="col" style="width:11%;">เบิกไปแล้ว</th>
                                            <th scope="col" style="width:11%;">เบิกได้อีก</th>
                                            <th scope="col" style="width:12%;">ราคา*</th>
                                        </tr>
                                        <tr style="text-align:center">
                                            <!--<td>ปุ๋ยเคมี</td>-->
                                            <td colspan="2">
                                                <mat-form-field appearance="fill">
                                                    <mat-label>ปุ๋ยเคมี</mat-label>
                                                    <mat-select disableRipple required formControlName="cemecal"
                                                        (selectionChange)="ChangeValue(1)">
                                                        <mat-option [value]="['',0,0,0,'']" selected>+++
                                                            ไม่เลือกสูตรปุ๋ยเคมี +++</mat-option>
                                                        <mat-option *ngFor="let item of stock_d1"
                                                            [value]="[item.stock_id,item.per_unit,item.amt_in,item.amt_out,item.description]">[{{item.stock_id}}]
                                                            | {{item.description}}</mat-option>
                                                    </mat-select>
                                                    <mat-hint>{{name_doc[0]}}</mat-hint>
                                                </mat-form-field>
                                                <!--
                                                <mat-form-field appearance="fill">
                                                    <mat-label>ปุ๋ยเคมี</mat-label>
                                                    <mat-select disableRipple required formControlName="cemecal"
                                                        (selectionChange)="ChangeValue(1)">
                                                        <mat-option [value]="['',0,0,0,'']" selected>+++
                                                            ไม่เลือกสูตรปุ๋ยเคมี +++</mat-option>
                                                        <mat-option *ngFor="let item of stock_d1"
                                                            [value]="[item.stock_id,item.per_unit,item.amt_in,item.amt_out,item.description]">[{{item.stock_id}}]
                                                            | {{item.description}}</mat-option>
                                                    </mat-select>
                                                    <mat-hint>{{name_doc[0]}}</mat-hint>
                                                </mat-form-field>
                                            -->

                                                <!--<select class="form-select" formControlName="cemecal"
                                            [ngClass]="{ 'is-invalid': submitted && factor.cemecal.errors }" (change)="ChangeValue(1)">
                                                <option selected [ngValue]="['',0,0,0]">+++ ไม่เลือกสูตรปุ๋ยเคมี +++</option>
                                                <option *ngFor="let item of stock_d1" [ngValue]="[item.stock_id,item.per_unit,item.amt_in,item.amt_out]">[{{item.stock_id}}] | {{item.description}}</option>
                                            </select>-->
                                            </td>
                                            <td>{{amt_1 | number}}</td>
                                            <td>
                                                <mat-form-field class="example-form-field" appearance="fill">
                                                    <input matInput type="number" min="0"
                                                        [ngModelOptions]="{standalone: true}" [(ngModel)]="amt_val1"
                                                        style="text-align:center" (change)="Change_amt(1)">
                                                </mat-form-field>
                                                <!-- 
                                            <div class="input-group mb-3">                                                
                                                <input type="number" min="0" class="form-control" formControlName="countcemecal" [(ngModel)]="amt_val1" id="countcem" (change)="Change_amt(1)" style="text-align:center" 
                                                [ngClass]="{ 'is-invalid': submitted && factor.countcemecal.errors }"value="0">                                                
                                            </div>-->
                                            </td>
                                            <td *ngFor="let list of oneplant" value="0">
                                                {{list.Getferted | number}}
                                            </td>
                                            <td *ngFor="let list of oneplant" value="0">
                                                {{list.caneGetfert12}}
                                            </td>
                                            <td>{{amt_last1 | number}}</td>
                                            <hr>
                                        </tr>
                                        <!--<div *ngIf="submitted && factor.cemecal.errors" class="invalid-feedback">
                                            <div *ngIf="factor.cemecal.errors.required">กรุณาเลือก สูตรปุ๋ย </div>
                                        </div>
                                        <div *ngIf="submitted && factor.countcemecal.errors" class="invalid-feedback">
                                            <div *ngIf="factor.countcemecal.errors.required">กรุณาระบุจำนวน ถ้าไม่มีให้ใส่ 0 </div>
                                        </div>-->

                                        <tr style="text-align:center">
                                            <!--<td>ปุ๋ยอินทรีย์</td>-->
                                            <td colspan="2">
                                                <mat-form-field appearance="fill">
                                                    <mat-label>ปุ๋ยอินทรีย์</mat-label>
                                                    <mat-select disableRipple required formControlName="fertilizer"
                                                        (selectionChange)="ChangeValue(2)">
                                                        <mat-option [value]="['',0,0,0,'']" selected>+++
                                                            ไม่เลือกปุ๋ยอินทรีย์ +++</mat-option>
                                                        <mat-option *ngFor="let item of stock_d2"
                                                            [value]="[item.stock_id,item.per_unit,item.amt_in,item.amt_out,item.description]">[{{item.stock_id}}]
                                                            | {{item.description}}</mat-option>
                                                    </mat-select>
                                                    <mat-hint>{{name_doc[1]}}</mat-hint>
                                                </mat-form-field>
                                                <!--
                                            <select class="form-select" formControlName="fertilizer"  (change)="ChangeValue(2)"
                                            [ngClass]="{ 'is-invalid': submitted && factor.fertilizer.errors }">
                                                <option selected [ngValue]="['',0,0,0]">+++ ไม่เลือกปุ๋ยอินทรีย์ +++</option>
                                                <option *ngFor="let item of stock_d2" [ngValue]="[item.stock_id,item.per_unit,item.amt_in,item.amt_out]">[{{item.stock_id}}] | {{item.description}}</option>
                                            </select>
                                            -->
                                            </td>
                                            <td>{{amt_2 | number}}</td>
                                            <td>
                                                <mat-form-field class="example-form-field" appearance="fill">
                                                    <input matInput type="number" min="0"
                                                        [ngModelOptions]="{standalone: true}" [(ngModel)]="amt_val2"
                                                        style="text-align:center" (change)="Change_amt(2)">
                                                </mat-form-field>
                                                <!--<div class="input-group mb-3">
                                                <input type="number" min="0" class="form-control" [ngModelOptions]="{standalone: true}" [(ngModel)]="amt_val2"  id="countfert" (change)="Change_amt(2)" style="text-align:center" 
                                                [ngClass]="{ 'is-invalid': submitted && factor.countfertilizer.errors }" value="0">
                                            </div>-->
                                            </td>
                                            <td *ngFor="let list of oneplant" value="0">
                                                {{list.GetOrganic}}
                                            </td>
                                            <td> <!--  {{cangetcaneOrganic}}--> </td>
                                            <td>{{amt_last2 | number }}</td>
                                            <hr>
                                        </tr>

                                        <!--<div *ngIf="submitted && factor.fertilizer.errors" class="invalid-feedback">
                                        <div *ngIf="factor.fertilizer.errors.required">กรุณาเลือกปุ๋ยอินทรีย์ </div>
                                    </div>
                                    <div *ngIf="submitted && factor.countfertilizer.errors" class="invalid-feedback">
                                        <div *ngIf="factor.countfertilizer.errors.required">กรุณาระบุจำนวน ถ้าไม่มีให้ใส่ 0 </div>
                                    </div>-->

                                        <tr style="text-align:center">
                                            <!--<td>โดโลไมท์</td>-->
                                            <td colspan="2">
                                                <mat-form-field appearance="fill">
                                                    <mat-label>โดโลไมท์</mat-label>
                                                    <mat-select disableRipple required formControlName="dolomite"
                                                        (selectionChange)="ChangeValue(3)">
                                                        <mat-option [value]="['',0,0,0,'']" selected>+++
                                                            ไม่เลือกโดโลไมท์ +++</mat-option>
                                                        <mat-option *ngFor="let item of stock_d4"
                                                            [value]="[item.stock_id,item.per_unit,item.amt_in,item.amt_out,item.description]">[{{item.stock_id}}]
                                                            | {{item.description}}</mat-option>
                                                    </mat-select>
                                                    <mat-hint>{{name_doc[2]}}</mat-hint>
                                                </mat-form-field>
                                                <!--
                                            <select class="form-select" formControlName="dolomite" (change)="ChangeValue(3)"
                                            [ngClass]="{ 'is-invalid': submitted && factor.dolomite.errors }">
                                                <option selected [ngValue]="['',0,0,0]">+++ ไม่เลือกรายการโดโลไมท์ +++</option>
                                                <option *ngFor="let item of stock_d4" [ngValue]="[item.stock_id,item.per_unit,item.amt_in,item.amt_out]">[{{item.stock_id}}] | {{item.description}}</option>
                                            </select>
                                            -->
                                            </td>
                                            <td>{{amt_3 | number}}</td>
                                            <td>
                                                <mat-form-field class="example-form-field" appearance="fill">
                                                    <input matInput type="number" min="0"
                                                        [ngModelOptions]="{standalone: true}" [(ngModel)]="amt_val3"
                                                        style="text-align:center" (change)="Change_amt(3)">
                                                </mat-form-field>
                                                <!--<div class="input-group mb-3">
                                                <input type="number" min="0" class="form-control" [ngModelOptions]="{standalone: true}" [(ngModel)]="amt_val3" id="countdolo" (change)="Change_amt(3)" style="text-align:center" 
                                                [ngClass]="{ 'is-invalid': submitted && factor.countdolomite.errors }" value="0">   
                                            </div>-->
                                            </td>
                                            <td *ngFor="let list of oneplant" value="0">
                                                {{list.GetDolomite}}
                                            </td>
                                            <td> <!--{{list.caneDolomites}}--> </td>
                                            <td>{{amt_last3 | number }}</td>
                                            <hr>
                                        </tr>

                                        <!--<div *ngIf="submitted && factor.dolomite.errors" class="invalid-feedback">
                                        <div *ngIf="factor.dolomite.errors.required">กรุณาเลือกโดโลไมท์ </div>
                                    </div>
                                    <div *ngIf="submitted && factor.countdolomite.errors" class="invalid-feedback">
                                        <div *ngIf="factor.countdolomite.errors.required">กรุณาระบุจำนวน ถ้าไม่มีให้ใส่ 0 </div>
                                    </div>-->

                                        <tr style="text-align:center">
                                            <!--<td>ยา</td>-->
                                            <td colspan="2">
                                                <mat-form-field appearance="fill">
                                                    <mat-label>ยา</mat-label>
                                                    <mat-select disableRipple required formControlName="medical"
                                                        (selectionChange)="ChangeValue(4)">
                                                        <mat-option [value]="['',0,0,0,'']" selected>+++
                                                            ไม่เลือกรายการยา +++</mat-option>
                                                        <mat-option *ngFor="let item of stock_d3"
                                                            [value]="[item.stock_id,item.per_unit,item.amt_in,item.amt_out,item.description]">[{{item.stock_id}}]
                                                            | {{item.description}}</mat-option>
                                                    </mat-select>
                                                    <mat-hint>{{name_doc[3]}}</mat-hint>
                                                </mat-form-field>
                                                <!--
                                            <select class="form-select" formControlName="medical" list="allmedical"  (change)="ChangeValue(4)"
                                            [ngClass]="{ 'is-invalid': submitted && factor.medical.errors }">
                                                <option selected [ngValue]="['',0,0,0]">+++ ไม่เลือกรายการยา +++</option>
                                                <option *ngFor="let item of stock_d3" [ngValue]="[item.stock_id,item.per_unit,item.amt_in,item.amt_out]">[{{item.stock_id}}] | {{item.description}}</option>
                                            </select>
                                            <input type="text" class="form-select" formControlName="medical" list="allmedical"  (change)="ChangeValue(4)"
                                            [ngClass]="{ 'is-invalid': submitted && factor.medical.errors }">
                                            <datalist id="allmedical">
                                                <option [ngValue]="['','0']" selected>[0000-0000] ไม่เลือกรายการยา </option>
                                                <option *ngFor="let item of medicdata" [ngValue]="[item.stock_id,item.per_unit,item.amt_credit]">[{{item.stock_id}}] | {{item.description}} , {{item.amt_credit | number}}บาท</option>
                                            </datalist>-->
                                            </td>
                                            <td>{{amt_4 | number}}</td>
                                            <td>
                                                <mat-form-field class="example-form-field" appearance="fill">
                                                    <input matInput type="number" min="0"
                                                        [ngModelOptions]="{standalone: true}" [(ngModel)]="amt_val4"
                                                        style="text-align:center" (change)="Change_amt(4)">
                                                </mat-form-field>
                                                <!--<div class="input-group mb-3">
                                                <input type="number" min="0" class="form-control" [ngModelOptions]="{standalone: true}" [(ngModel)]="amt_val4" id="countmedi" (change)="Change_amt(4)" style="text-align:center" 
                                                [ngClass]="{ 'is-invalid': submitted && factor.countmedical.errors }" value="0">                                                
                                            </div>-->
                                            </td>
                                            <td></td>
                                            <td></td>
                                            <td>{{amt_last4 | number }}</td>
                                            <hr>
                                        </tr>
                                        <!--<div *ngIf="submitted && factor.medical.errors" class="invalid-feedback">
                                        <div *ngIf="factor.medical.errors.required">กรุณารายการยา </div>
                                    </div>
                                    <div *ngIf="submitted && factor.countmedical.errors" class="invalid-feedback">
                                        <div *ngIf="factor.countmedical.errors.required">กรุณาระบุจำนวน ถ้าไม่มีให้ใส่ 0 </div>
                                    </div>-->
                                        <tr style="text-align:center">
                                            <!--<td>อุปกรณ์</td>-->
                                            <td colspan="2">
                                                <mat-form-field appearance="fill">
                                                    <mat-label>อุปกรณ์</mat-label>
                                                    <mat-select disableRipple required formControlName="machine"
                                                        (selectionChange)="ChangeValue(5)">
                                                        <mat-option [value]="['',0,0,0,'']" selected>+++ ไม่เลือกอุปกรณ์
                                                            +++</mat-option>
                                                        <mat-option *ngFor="let item of stock_d5"
                                                            [value]="[item.stock_id,item.per_unit,item.amt_in,item.amt_out,item.description]">[{{item.stock_id}}]
                                                            | {{item.description}}</mat-option>
                                                    </mat-select>
                                                    <mat-hint>{{name_doc[4]}}</mat-hint>
                                                </mat-form-field>
                                                <!--
                                            <select id="machinelist" class="form-select" placeholder="++ เลือกรายการอุปกรณ์ ++" formControlName="machine"  list="machinelist" (change)="ChangeValue(5)"
                                            [ngClass]="{ 'is-invalid': submitted && factor.machine.errors }">
                                                <option [ngValue]="['',0,0,0]" selected>+++ ไม่เลือกรายการอุปกรณ์ +++</option>
                                                <option *ngFor="let item of stock_d5" [ngValue]="[item.stock_id,item.per_unit,item.amt_in,item.amt_out]">[{{item.stock_id}}] | {{item.description}}</option>
                                            </select> 
                                            <datalist id="machinelist">
                                                <option [ngValue]="['','0']" selected>[0000-0000] ไม่เลือกรายการอุปกรณ์ </option>
                                                <option *ngFor="let item of machinedata" [ngValue]="[item.stock_id,item.per_unit,item.amt_credit]">[{{item.stock_id}}] | {{item.description}} , {{item.amt_credit | number}}บาท</option>
                                            </datalist>-->
                                            </td>
                                            <td>{{amt_5 | number}}</td>
                                            <td>
                                                <mat-form-field class="example-form-field" appearance="fill">
                                                    <input matInput type="number" min="0"
                                                        [ngModelOptions]="{standalone: true}" [(ngModel)]="amt_val5"
                                                        style="text-align:center" (change)="Change_amt(5)">
                                                </mat-form-field>
                                                <!--<div class="input-group mb-3">
                                                <input type="number" min="0" class="form-control" [ngModelOptions]="{standalone: true}" [(ngModel)]="amt_val5" id="countmach" (change)="Change_amt(5)" style="text-align:center" 
                                                [ngClass]="{ 'is-invalid': submitted && factor.countmachine.errors }" value="0">                                                
                                            </div>-->
                                            </td>
                                            <td></td>
                                            <td></td>
                                            <td>{{amt_last5 | number }}</td>
                                            <hr>
                                        </tr>
                                        <!--<div *ngIf="submitted && factor.machine.errors" class="invalid-feedback">
                                        <div *ngIf="factor.machine.errors.required">กรุณาเลือกอุปกรณ์ </div>
                                    </div>
                                    <div *ngIf="submitted && factor.countmachine.errors" class="invalid-feedback">
                                        <div *ngIf="factor.countmachine.errors.required">กรุณาระบุจำนวน ถ้าไม่มีให้ใส่ 0 </div>
                                    </div>-->
                                        <tfoot>
                                            <tr style="text-align:center">
                                                <td style="text-align:center">
                                                    <input class="form-check-input mt-0" type="checkbox"
                                                        [ngModelOptions]="{standalone: true}" [(ngModel)]="ckcash"
                                                        name="cash0" (change)="ckack()"> <label for="cash0">
                                                        เงินสด</label>
                                                </td>
                                                <td colspan="3" style="color: red;">
                                                    หากไม่ได้เบิกส่วนอื่น ๆ ให้เลือก ไม่เลือกรายการ ให้กรอกจำนวน 0
                                                </td>
                                                <td colspan="2" style="text-align:right">รวมทั้งหมด | </td>
                                                <td style="color: red;" scope="row">{{sum_amtlast | number }}</td>
                                            </tr>
                                        </tfoot>
                                    </table>
                                    <hr>
                                </form>
                                <div>
                                    <button class="btn btn-info float-left" (click)="Savedatafactor();"
                                        *ngIf="main_stock.length>0 &&!ckfarmercan && oneplant.length>0">บันทึก</button>
                                    <button class="btn btn-warning float-right" (click)="cleardata();">กรอกใหม่</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- ฟอร์มบันทึกกรอกปัจจัย -->
                </div>
            </div>
        </div>
        <!-- แบบบันทึกทั้งหมดนั่นล่ะ -->
        <!--  รายการแสดงเบิกปัจจัย -->
        <div class="card">
            <div class="card-body">
                <div class="card-header">
                    <i class="fas fa-table"></i> ข้อมูลการเบิกปัจจัย ปี 66/67 ({{famername}})
                </div>
                <div class="card-body table-responsive p-2" style="height: 600px">
                    <table class="table table-hover table-head-fixed text-nowrap">
                        <thead>
                            <tr class="headText text-primary text-center">
                                <th>_</th>
                                <th>เลขที่ </th>
                                <th>วันที่</th>
                                <th>ชื่อ</th>
                                <th>แปลง</th>
                                <th>รายการ</th>
                                <th>สต็อค</th>
                                <th>ราคารวม</th>
                                <th>พิมพ์</th>
                                <th>ยกเลิก</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="text-center" *ngFor="let data of onecode; let i = index;">
                                <td>{{i+1}}</td>
                                <td style="text-align:left">{{data.docid }} <b *ngIf="data.take_method === 1"
                                        style="color: red;">(เงินสด)</b></td>
                                <td>{{data.datepost_th}}</td>
                                <td>{{data.fmname}}</td>
                                <td>{{data.intlandno}}</td>
                                <td style="text-align:left">
                                    <mat-label *ngIf="data.amt1>0">- {{data.desc1}} * <span
                                            class="badge badge-pill badge-primary"> {{data.amt1}} </span> -</mat-label>
                                    <mat-label *ngIf="data.amt2>0">- {{data.desc2}} * <span
                                            class="badge badge-pill badge-primary"> {{data.amt2}} </span> -</mat-label>
                                    <mat-label *ngIf="data.amt4>0">- {{data.desc4}} * <span
                                            class="badge badge-pill badge-primary"> {{data.amt4}} </span> -</mat-label>
                                    <mat-label *ngIf="data.amt3>0">- {{data.desc3}} * <span
                                            class="badge badge-pill badge-primary"> {{data.amt3}} </span> -</mat-label>
                                    <mat-label *ngIf="data.amt5>0">- {{data.desc5}} * <span
                                            class="badge badge-pill badge-primary"> {{data.amt5}} </span> -</mat-label>
                                </td>
                                <td>{{data.Stockname}}</td>
                                <td style="text-align:right">{{data.money_amt | number}}</td>
                                <td>
                                    <button class="btn btn-sm">
                                        <a [routerLink]="['/docfertilizer/6667/'+data.fmcode+'/'+data.docid+'/0']"
                                            routerLinkActive="active" target="_blank"><i class="fas fa-print"></i></a>
                                    </button>
                                </td>
                                <td><a (click)="cancledata(data.docid)"> <i class="far fa-window-close"
                                            style='color:red'></i></a></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <!--  รายการแสดงเบิกปัจจัย -->
    </div>
</div>
<app-footer></app-footer>